import React from 'react';
import globals from "../globals";
import HelmetDefault from "../layout/HelmetDefault";
import Hero from "../modules/Hero/Hero";
import RegisterBlock from "../modules/RegisterBlock";
import TwoColumnTextBlocks from "../modules/TwoColumnTextBlocks";

class IpTransit extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			title: '',
			subTitle: '',
			leadCopy: [],
			seoTitle: '',
			seoDescription: '',
			twoColumn: {
				title: '',
				content: '',
				textBlocks: []
			}
		}
	}

	componentDidMount() {
		this.getData();
	}

	getData() {
		fetch('/api/network-solutions/ip-transit')
			.then(result => result.json())
			.then((result) => {
				this.setState(result);
				this.setDataReceived();
				globals.animatePageIn(this.container);
			});
	}

	setDataReceived() {
		this.setState({
			dataReceived: true
		});
	}

	render() {
		return (
			<div ref={(el) => this.container = el} style={{opacity: 0}} className="ip-transit">
				<HelmetDefault {...this.state} />
				<Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
				<TwoColumnTextBlocks title={this.state.twoColumn.title} textBlocks={this.state.twoColumn.textBlocks}>
					<div className="d-inline-block">
						<ul>
							<li><span className="bold">Once-only installation</span> - Exetel COLO<br />(customer to provide cross connect to Exetel's PoP)</li>
							<li><span className="bold">1 Gbps bearer</span> - Once only install - $1,000/port</li>
							<li><span className="bold">Redundant Copper Port</span> - $50/mth</li>
							<li><span className="bold">Redundant Fibre Port</span> - $250/mth</li>
						</ul>
					</div>
				</TwoColumnTextBlocks>
				<RegisterBlock />
			</div>
		);
	}

}

export default IpTransit;


// WEBPACK FOOTER //
// ./resources/assets/js/networkSolutions/IpTransit.js